function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { createForm } from '@formily/core';
import { FormProvider, RecursionField, SchemaComponentsContext } from '@formily/react';
import { observer } from '@formily/reactive-react';
import { Tree } from 'antd';
import cx from 'classnames';
import React, { useContext, useEffect, useState } from 'react';
import { useCssInJs, useModal } from "../../../../hooks";
import BatchImportIcon from "../../Icon/BatchImportIcon";
import OrganizationStructIcon from "../../Icon/OrganizationStructIcon";
import RegionIcon from "../../Icon/RegionIcon";
import { importShopSchema, importUserSchema } from "../../const";
import { SHOPTYPE, useSelectStore } from "../../useSearchList";
import { genTreeViewStyles } from "./styles";
export var TreeView = observer(function () {
  var components = useContext(SchemaComponentsContext);
  var prefix = 'form-batch-picker-tree-view';
  var modal = useModal();
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genTreeViewStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var store = useSelectStore();
  var mode = store.mode,
    shopType = store.shopType,
    isCustomShopType = store.isCustomShopType,
    checkedKeys = store.checkedKeys,
    onCheck = store.onCheck;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    expandedKeys = _useState2[0],
    setExpandedKeys = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedKeys = _useState4[0],
    setSelectedKeys = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    autoExpandParent = _useState6[0],
    setAutoExpandParent = _useState6[1];
  var onExpand = function onExpand(expandedKeysValue) {
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };
  var onSelect = function onSelect(selectedKeysValue, info) {
    var key = info.node.key;
    var isExpanded = expandedKeys.includes(key);

    // 定义一个递归函数来获取所有子节点的key
    var getAllChildKeys = function getAllChildKeys(node) {
      var keys = [];
      if (node.children) {
        node.children.forEach(function (child) {
          keys.push.apply(keys, [child.key].concat(_toConsumableArray(getAllChildKeys(child))));
        });
      }
      return keys;
    };

    // 如果当前节点已展开，则需要收起该节点及其所有子节点
    // 如果当前节点未展开，则仅需展开当前节点
    var newExpandedKeys = isExpanded ? expandedKeys.filter(function (k) {
      return k !== key && !getAllChildKeys(info.node).includes(k);
    }) : [].concat(_toConsumableArray(expandedKeys), [key]);
    setExpandedKeys(newExpandedKeys);
    setSelectedKeys(selectedKeysValue);
  };
  var handleTreeType = function handleTreeType(e, type) {
    e.preventDefault();
    // 只有没展开的时候点击才有效
    if (type !== store.shopType) {
      store.shopType = type;
      store.treeData = [];
    }
  };
  useEffect(function () {
    store.loadTree();
  }, [store.shopType]);
  var handleImport = function handleImport() {
    var form = createForm();
    var batchImportUserschema = mode === 'store' ? importShopSchema : importUserSchema;
    modal.confirm({
      icon: null,
      title: "\u6279\u91CF\u5BFC\u5165".concat(mode === 'store' ? '门店' : '用户'),
      content: /*#__PURE__*/React.createElement(FormProvider, {
        form: form
      }, /*#__PURE__*/React.createElement(SchemaComponentsContext.Provider, {
        value: components
      }, /*#__PURE__*/React.createElement(RecursionField, {
        schema: batchImportUserschema
      }))),
      onOk: function onOk() {
        return form.submit().then(function (result) {
          // console.log('result', result)

          store.onBatchImport(result);
        }).catch(function (error) {
          console.log('error', error);
        });
      }
    })
    // @ts-ignore
    .then().catch(function (error) {
      console.log('error', error);
    });
  };
  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, prefix)
  }, /*#__PURE__*/React.createElement("div", {
    className: "headerItem",
    onClick: handleImport
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(BatchImportIcon, null)), /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, "\u6279\u91CF\u5BFC\u5165")), mode === 'store' && !isCustomShopType ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: cx('headerItem', {
      selectedType: shopType === SHOPTYPE.ORG
    }),
    onClick: function onClick(ev) {
      return handleTreeType(ev, SHOPTYPE.ORG);
    }
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(OrganizationStructIcon, null)), /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, "\u7EC4\u7EC7\u67B6\u6784")), shopType === SHOPTYPE.ORG ? /*#__PURE__*/React.createElement("div", {
    className: "treeWrap"
  }, /*#__PURE__*/React.createElement(Tree, {
    checkable: true,
    onExpand: onExpand,
    expandedKeys: expandedKeys,
    autoExpandParent: autoExpandParent,
    onCheck: onCheck,
    height: 300,
    checkedKeys: checkedKeys,
    onSelect: onSelect,
    selectedKeys: selectedKeys,
    treeData: store.treeData,
    blockNode: true
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: cx('headerItem', {
      selectedType: shopType === SHOPTYPE.CITY
    }),
    onClick: function onClick(ev) {
      return handleTreeType(ev, SHOPTYPE.CITY);
    }
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(RegionIcon, null)), /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, "\u884C\u653F\u533A")), shopType === SHOPTYPE.CITY ? /*#__PURE__*/React.createElement("div", {
    className: "treeWrap"
  }, /*#__PURE__*/React.createElement(Tree, {
    checkable: true,
    onExpand: onExpand,
    expandedKeys: expandedKeys,
    autoExpandParent: autoExpandParent,
    onCheck: onCheck,
    height: 300,
    checkedKeys: checkedKeys,
    onSelect: onSelect,
    selectedKeys: selectedKeys,
    treeData: store.treeData,
    blockNode: true
  })) : null) : null, mode === 'user' || mode === 'store' && isCustomShopType ? /*#__PURE__*/React.createElement("div", {
    className: "treeWrap"
  }, /*#__PURE__*/React.createElement(Tree, {
    checkable: true,
    onExpand: onExpand,
    expandedKeys: expandedKeys,
    autoExpandParent: autoExpandParent,
    onCheck: onCheck,
    height: 380,
    checkedKeys: checkedKeys,
    onSelect: onSelect,
    selectedKeys: selectedKeys,
    treeData: store.treeData,
    blockNode: true
  })) : null));
});